import { render, staticRenderFns } from "./ProLabel.vue?vue&type=template&id=56b67696&"
import script from "./ProLabel.vue?vue&type=script&lang=ts&"
export * from "./ProLabel.vue?vue&type=script&lang=ts&"
import style0 from "./ProLabel.vue?vue&type=style&index=0&id=56b67696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports